import * as React from "react";
import { UtilitiesAccountFields } from "./UtilitiesAccountFields";
import { AccountFieldProps } from "./types/AccountFieldProps";
export type WaterAccountFieldsProps = AccountFieldProps;

export const WaterAccountFields: React.FC<WaterAccountFieldsProps> = ({
  properties,
  persons,
  serviceProvider,
  account,
  setBusy,
  uploadedFileInfo,
  createDocument,
  onAccountAdded = () => {},
  updateTemplate,
  saveAccount,
  saveRecord,
  savedRecord,
}) => {
  return (
    <UtilitiesAccountFields
      properties={properties}
      persons={persons}
      serviceProvider={serviceProvider}
      setBusy={setBusy}
      onAccountAdded={onAccountAdded}
      account={account}
      uploadedFileInfo={uploadedFileInfo}
      createDocument={createDocument}
      version={"water"}
      updateTemplate={updateTemplate}
      saveAccount={saveAccount}
      saveRecord={saveRecord}
      savedRecord={savedRecord}
    />
  );
};
